var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKalkulatrixLogoDarkOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 103.5",
    style: {
      enableBackground: "new 0 0 425.2 103.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#1D1D1B;}\r\n\t.st4{fill:none;stroke:#1D1D1B;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.81,76.39V26.08h9.87v50.31H65.81z M85.73,76.39l-9.62-26.13l9.45-24.17h10.56l-10.3,24.17l10.64,26.13 H85.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.15,76.39l9.02-50.31h14.13l8.85,50.31h-11.07l-1.53-9.28h-7.32l-1.45,9.28H98.15z M110.41,62.18h7.07 l-3.49-27.33L110.41,62.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M134.76,76.39V26.08h9.79v43.5h11.41v6.81H134.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.55,76.39V26.08h9.87v50.31H160.55z M180.47,76.39l-9.62-26.13l9.45-24.17h10.56l-10.3,24.17 l10.64,26.13H180.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M209.58,77.41c-2.04,0-3.92-0.14-5.62-0.43s-3.18-0.88-4.43-1.79c-1.25-0.91-2.21-2.26-2.89-4.04 c-0.68-1.79-1.02-4.21-1.02-7.28v-37.8h9.87v40.6c0,1.19,0.18,2.14,0.55,2.85c0.37,0.71,0.86,1.18,1.49,1.4 c0.62,0.23,1.31,0.34,2.04,0.34c0.68,0,1.33-0.11,1.96-0.34c0.62-0.23,1.12-0.69,1.49-1.4c0.37-0.71,0.55-1.66,0.55-2.85v-40.6 h9.87v37.8c0,3.01-0.34,5.42-1.02,7.24c-0.68,1.82-1.63,3.18-2.85,4.09c-1.22,0.91-2.7,1.5-4.43,1.79 C213.42,77.27,211.57,77.41,209.58,77.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.78,76.39V26.08h9.79v43.5h11.41v6.81H230.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M253.67,76.39l9.02-50.31h14.13l8.85,50.31h-11.07l-1.53-9.28h-7.32l-1.45,9.28H253.67z M265.93,62.18H273 l-3.49-27.33L265.93,62.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.75,76.39V33.06h-7.83v-6.98h25.54v6.98h-7.83v43.33H292.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.13,76.39V26.08h18.39c3.35,0,5.87,0.75,7.58,2.26c1.7,1.5,2.55,3.59,2.55,6.26v7.83 c0,2.67-0.71,4.91-2.13,6.72c-1.42,1.82-3.63,2.87-6.64,3.15c1.93,0.28,3.31,0.92,4.13,1.92c0.82,0.99,1.55,2.6,2.17,4.81 l4.77,17.37h-10.98l-3.66-16.68c-0.34-1.36-0.72-2.51-1.15-3.45c-0.43-0.94-1.04-1.4-1.83-1.4h-2.89v21.54H315.13z M325.43,47.96 h4.09c1.59,0,2.72-0.44,3.41-1.32c0.68-0.88,1.02-2.28,1.02-4.21v-6.04c0-1.82-0.31-3.09-0.94-3.83 c-0.63-0.74-1.59-1.11-2.89-1.11h-4.68V47.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351.23,76.39V26.08h9.87v50.31H351.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.87,76.39l7.41-25.88l-6.98-24.43h9.88l4.43,16.77l4.34-16.77h10.39l-7.15,24.43l6.98,25.88h-9.87 l-4.6-16.77l-4.34,16.77H365.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.12,
    y: 26.38,
    className: "st2",
    width: 25.66,
    height: 25.36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.12,
    y: 51.75,
    className: "st3",
    width: 25.66,
    height: 25.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.78,77.41H27.12c-0.17,0-0.3-0.13-0.3-0.3V26.38c0-0.17,0.13-0.3,0.3-0.3h25.66c0.17,0,0.3,0.13,0.3,0.3 v50.73C53.08,77.28,52.95,77.41,52.78,77.41z M27.42,76.81h25.06V26.68H27.42V76.81z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "46.77,37.01 42.01,37.01 42.01,32.25 37.89,32.25 37.89,37.01 33.13,37.01 33.13,41.13 37.89,41.13  37.89,45.89 42.01,45.89 42.01,41.13 46.77,41.13  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.98,
    y: 62.37,
    className: "st2",
    width: 11.94,
    height: 4.12
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalkulatrixLogoDarkOutline);
export default __webpack_public_path__ + "static/media/kalkulatrix_logo_dark_outline.94f3526495ee2b055e9b17252f37a042.svg";
export { ForwardRef as ReactComponent };